import type { KeyboardEvent, PointerEvent } from 'react';

import { Box } from '@mantine/core';

import { AGENT_PANEL_KEY_STEP, type AgentPanelWidth } from './agentPanel';

/**
 * The left edge of the agent panel, which the person drags to make the panel
 * wider or narrower. The arrow keys move it too.
 */
export function AgentResizeHandle({ width, setWidth, setResizing }: AgentPanelWidth) {
  // The panel ends at the right edge of the screen, so its width is the
  // distance from the pointer to that edge.
  const widthAt = (event: PointerEvent<HTMLDivElement>) => window.innerWidth - event.clientX;

  return (
    <Box
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize the agent"
      aria-valuenow={width}
      tabIndex={0}
      pos="absolute"
      top={0}
      bottom={0}
      left={-3}
      w={6}
      style={{ cursor: 'col-resize', zIndex: 1, touchAction: 'none' }}
      onPointerDown={(event: PointerEvent<HTMLDivElement>) => {
        event.currentTarget.setPointerCapture(event.pointerId);
        setResizing(true);
      }}
      onPointerMove={(event: PointerEvent<HTMLDivElement>) => {
        if (event.currentTarget.hasPointerCapture(event.pointerId)) setWidth(widthAt(event));
      }}
      onPointerUp={(event: PointerEvent<HTMLDivElement>) => {
        event.currentTarget.releasePointerCapture(event.pointerId);
        setResizing(false);
      }}
      onLostPointerCapture={() => setResizing(false)}
      onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'ArrowLeft') setWidth(width + AGENT_PANEL_KEY_STEP);
        else if (event.key === 'ArrowRight') setWidth(width - AGENT_PANEL_KEY_STEP);
        else return;
        event.preventDefault();
      }}
    />
  );
}
